module.exports = __webpack_public_path__ + "static/media/1.20e984ac.png";